import { getUser } from '@frontend/auth-helpers';
import { MigrationConfig } from './utils/migration';

const user = getUser();
export const migrationConfigs: MigrationConfig[] = [
  {
    localKey: 'ForYouNotificationFilters',
    prefId: 'ForYouNotificationFilters',
    transform: (value) => value.state.forYouNotificationFilters,
  },
  {
    localKey: `${user?.userID}widgetConfigs`,
    prefId: 'WidgetConfigs',
    transform: (value) => value,
    featureFlagName: 'dashboard-user-preference-sync',
  },
];
